module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEzSURBVHgBzVPRTcMwEH12w39HCPyUftERsgFNF0g2QExAmYAwAekApGECZuArqF/tBu0A9XFuhRITC59AlfqkOM7l3Ts/+wycO5SIla7e3awoR3W18VE1RGUp4WcNmI/D/BfIBC2MWYCoCNGiEAHTJj68lX6CANGPxNj9rYfswQrVUGz3iDeY3S4sqJHz8NBjEFtdjnMIITtlH9LPAkrddio/o7ouOpZXE2A/kSvqG9B+A0IJbZ3R0EY7lk3Cwx3EsAK6xnJUcp9m317/Ybkp+eSzNmAeUY3n7QpnTQ4aZL1ETSVeR4tenAYFWy47kbW7wmmT8EknbhK3kV2F4g7wiXoQtjxr5v12uoj/fpd5X44TuodBGqLL7zJoyxu/DbHCd7mt/SIpLxM05tL5rv37dxJ8ARVYV+LGnwKsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxpclit1.png
// module id = 3LjA
// module chunks = 0